export default {
    900008: 'Hello, your operation is too frequent, please try again later',
    900005: 'The resource no longer exists',
    900004: 'File type is not supported',
    900003: 'File size exceeds limit',
    900002: 'The format is wrong',
    900001: 'Attribute value is required',
    900000: 'Verification failed, please try again',
    20106: 'The phone number has been occupied, please input again',
    20105: 'The mailbox has been occupied, please input again',
    20138: 'The one-time verification code expires and may have been bound to the mailbox. Please re-bind the mailbox.',
    1: 'Operation failed, you do not have this permission',
    2: 'The operation failed. Please try again later',
    3: 'The operation failed. Please try again later',
    504: '请求超时',
    910001: 'The data type is wrong',
    910003: 'Required fields',
    910002: 'Exceed length limit',
    30142: 'Unauthorized exam access',
    90901: 'Your account has been logged in on another device or browser. Please login again',
    10202: 'Have reported, please wait for the review!',
    90902: 'Your account has been logged in on another device, please login again',
    30148: 'Must pass the exam before viewing the details',
    10203: 'The resources you\'d like to report no longer exist!',
    900009: 'Hello, your operation is too frequent today, please come back tomorrow',
    990001: 'Upload failed, the image size cannot be greater than 5M',
    21901: 'The receiving address has reached the upper limit.',
    21902: 'There is no right to operate the receipt address.',
    20147: 'Email verification code expired',
    20146: 'Please add a mobile phone or email first',
    20134: 'Invalidate verification code',
    20133: 'Mobile verification code is empty',
    20150: 'The mailbox is empty',
    201502: 'File cannot be empty',
    10134: 'message failed to be sended',
    90903: 'Log in too many times, the account has been restricted, please log in later',
    20149: 'Mobile number is empty',
    21903: 'File service exception, please try again.',
    21904: '文件上传异常',
    40323: '配置推送内容和学员均为必填项',
};
